<div #latLongSelectToggle class="lat-long-select-toggle" (click)="showLatLongSelect = !showLatLongSelect;">
    <span class="icon-ui-globe toggle-icon"></span>
</div>
<div #latLongSelectContainer class="lat-long-select">
    <input *ngIf="showLatLongSelect" type="number" [ngModel]="lat" (ngModelChange)="onLatChange($event)">
    <input *ngIf="showLatLongSelect" type="number" [ngModel]="long" (ngModelChange)="onLongChange($event)">
</div>